class ModalDialog extends HTMLElement {
    constructor() {
      super();
  
      this.modal = this.querySelector('.modal');
     
      this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
      if(this.modalOpeners.length > 0) {
        this.modalOpeners.forEach((opener)=>{
          opener.addEventListener('click', ()=>{
            this.show(opener);
          });
        });
      }
  
      if(this.querySelector('[id^="ModalClose-"]')){
        this.querySelector('[id^="ModalClose-"]').addEventListener(
          'click',
          this.hide.bind(this)
        );
      }
  
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
  
      this.addEventListener('keyup', () => {
         if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
  
    }
  
    show(opener) {
      this.openedBy = opener;
      this.modal.classList.add('open');
      siteOverlay.prototype.showOverlay();
      Utility.trapFocus(this);
      Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
    }
  
    hide() {
        document.body.classList.remove('overflow-hidden');
        this.modal.classList.remove('open');
        siteOverlay.prototype.hideOverlay();
        Utility.removeTrapFocus(this.openedBy);
    
        if(this.id == 'PopupModal-video' && document.getElementsByTagName('custom-video')){
            this.querySelector('.video-section').innerHTML = '';
            document.querySelector('custom-video').classList.remove('show--video');
        }
    }
  }
  customElements.define('modal-dialog', ModalDialog);